




import Vue from 'vue'

export default Vue.extend({
  name: "ActionButton",
  props: {
    onBtnClick: Function
  }
})
